<script>
    import { createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';
    import ArForm from './forms/ArForm.svelte';
    import ArShare from './share/ArShare.svelte';
    import Loader from './Loader.svelte';
    import { toBody } from '../../utils.js';

    let dispatch = createEventDispatcher();
    let popup;
    let state = 'model';
    let shareUrl;
    let qrSrc;
    let unsupported = false;

    function handleClickClose() {
        dispatch('close');
    }

    function handleOuterClick(event) {
        if (!popup.contains(event.target)) {
            dispatch('close');
        }
    }

    function handleShare(event) {
        shareUrl = event.detail.url;
        qrSrc = event.detail.qr;
        unsupported = event.detail.unsupported;
        state = 'share';
    }

    function handleLoading() {
        state = 'loading';
    }
</script>

<svelte:body on:mousedown={handleOuterClick} />

<div class="arsize_widget_block arsize_color_green" transition:fade={{duration: 200}} use:toBody>
    <div class="arsize_widget_wr" bind:this="{popup}">
        <div class="arsize_close" on:click={handleClickClose}><span class="arsize_close_span"></span></div>
        <div class="arsize_body">
            {#if state === 'share'}
                <ArShare url={shareUrl} qr={qrSrc} {unsupported} />
            {:else if state === 'loading'}
                <Loader />
            {:else}
                <ArForm on:share={handleShare} on:loading={handleLoading} on:showAr />
            {/if}
        </div>
    </div>
</div>

<style>
	@font-face {
		font-family: "Ubuntu";
		src: url("/fonts/ubuntu-r-webfont.eot");
		src: url("/fonts/ubuntu-r-webfont.eot?#iefix") format("embedded-opentype"), url("/fonts/ubuntu-r-webfont.woff") format("woff");
		font-weight: normal;
		font-style: normal;
	}
	@font-face {
		font-family: "Ubuntu";
		src: url("/fonts/ubuntu-m-webfont.eot");
		src: url("/fonts/ubuntu-m-webfont.eot?#iefix") format("embedded-opentype"), url("/fonts/ubuntu-m-webfont.woff") format("woff");
		font-weight: 500;
		font-style: normal;
	}
	@font-face {
		font-family: "Ubuntu";
		src: url("/fonts/ubuntu-b-webfont.eot");
		src: url("/fonts/ubuntu-b-webfont.eot?#iefix") format("embedded-opentype"), url("/fonts/ubuntu-b-webfont.woff") format("woff");
		font-weight: bold;
		font-style: normal;
	}
    div {
        box-sizing: border-box;
    }
    .arsize_widget_block {
        box-sizing: border-box;
        font-size: 18px;
        color: #243955;
        line-height: 1.3;
        font-weight: normal;
        background-color: rgba(0, 0, 0, .4);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999998;
        opacity: 1;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        outline: 0;
        transition: opacity .1s linear;
        font-family: "Ubuntu";
    }
    .arsize_widget_wr {
        position: relative;
        transform: none;
        transition: transform .3s ease-out;
        background: #fff;
        box-shadow: 0 0 16px rgba(36, 57, 85, .3);
        border-radius: 24px;
        width: 1242px;
        max-width: 1242px;
        margin: 24px auto;
        min-height: 628px;
    }
    .arsize_close {
        position: absolute;
        right: 50px;
        top: 24px;
        width: 50px;
        height: 50px;
        color: #fff;
        z-index: 9999999;
        cursor: pointer;
        border-radius: 50%;
    }
    .arsize_close_span {
        width: 50px;
        height: 50px;
        display: block;
        background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjE3IDExTDIxLjQyNDQgNC43NDU2MkMyMi4xOTE5IDMuOTc4MTIgMjIuMTkxOSAyLjczMzc1IDIxLjQyNDQgMS45NjU2MkwyMC4wMzQ0IDAuNTc1NjI1QzE5LjI2NjkgLTAuMTkxODc1IDE4LjAyMjUgLTAuMTkxODc1IDE3LjI1NDQgMC41NzU2MjVMMTEgNi44M0w0Ljc0NTYzIDAuNTc1NjI1QzMuOTc4MTMgLTAuMTkxODc1IDIuNzMzNzUgLTAuMTkxODc1IDEuOTY1NjMgMC41NzU2MjVMMC41NzU2MjUgMS45NjU2MkMtMC4xOTE4NzUgMi43MzMxMiAtMC4xOTE4NzUgMy45Nzc1IDAuNTc1NjI1IDQuNzQ1NjJMNi44MyAxMUwwLjU3NTYyNSAxNy4yNTQ0Qy0wLjE5MTg3NSAxOC4wMjE5IC0wLjE5MTg3NSAxOS4yNjYyIDAuNTc1NjI1IDIwLjAzNDRMMS45NjU2MyAyMS40MjQ0QzIuNzMzMTIgMjIuMTkxOSAzLjk3ODEzIDIyLjE5MTkgNC43NDU2MyAyMS40MjQ0TDExIDE1LjE3TDE3LjI1NDQgMjEuNDI0NEMxOC4wMjE5IDIyLjE5MTkgMTkuMjY2OSAyMi4xOTE5IDIwLjAzNDQgMjEuNDI0NEwyMS40MjQ0IDIwLjAzNDRDMjIuMTkxOSAxOS4yNjY5IDIyLjE5MTkgMTguMDIyNSAyMS40MjQ0IDE3LjI1NDRMMTUuMTcgMTFaIiBmaWxsPSJ3aGl0ZSI+PC9wYXRoPgo8L3N2Zz4=") no-repeat center;
    }
    .arsize_color_green .arsize_close {
        background-color: #4CC499;
    }
    @media (max-width: 1279.98px) {
        .arsize_widget_block {
            font-size: 14px;
        }
        .arsize_widget_wr {
            width: 327px;
            max-width: none;
            margin: 15px auto;
            min-height: 300px;
            border-radius: 12px;
        }
        .arsize_close {
            right: 8px;
            top: 15px;
            width: 32px;
            height: 32px;
            padding: 10px 10px;
        }
        .arsize_close_span {
            width: 12px;
            height: 12px;
            background-size: contain;
        }
    }
</style>